import { Box } from '@lemonade-hq/cdk';
import type { HowItWorksProps } from '../';
import { PizzaContainer } from './PizzaContainer';
import { PizzaDesktop } from './PizzaDesktop';
import { PizzaMobile } from './PizzaMobile';

type PizzaAreaProps = Pick<HowItWorksProps, 'pizzaBreakPoint' | 'pizzaDesktop' | 'pizzaMobile' | 'showBrandsImage'>;

export const PizzaArea: React.FC<PizzaAreaProps> = ({ pizzaDesktop, pizzaMobile, showBrandsImage = true }) => {
  return (
    <PizzaContainer showBrandsImage={showBrandsImage} aria-hidden={true}>
      <Box display={['none', 'block']}>
        <PizzaDesktop pizzaDesktop={pizzaDesktop} />
      </Box>
      <Box display={['block', 'none']}>
        <PizzaMobile pizzaMobile={pizzaMobile} />
      </Box>
    </PizzaContainer>
  );
};
